import content from "./jsonParsers/content.json";

const LandingSet = {
  title1: content.Opening.Title,
  landingCopy: content.Opening.Subtitle,
  landingCopy2: content.Opening.Subtitle2,
  getStarted: content.Buttons.getStarted,
  restartBtn: content.Buttons.restart,
  nextBtn: content.Buttons.next,
  finishBtn: content.Buttons.finish,
  languages: content.Opening.Languages,
};

export default LandingSet;
